<div class="relative">
  <div class="relative">
    <div #scrollable class="flex flex-row overflow-x-scroll snap-x snap-mandatory" style="scrollbar-width: none;">
      @for(event of events(); track event.uniqueId; let i = $index; let first = $first) {
        <div class="snap-start min-w-full px-4 pb-10">
          <app-event-card [event]="event" [shouldLoadEagerly]="first"></app-event-card>
        </div>
      }
    </div>

    <div class="z-10 absolute pointer-events-none left-4 right-4 top-0 aspect-cover flex items-center">
      <div class="px-4 min-w-full flex flex-row">
        @if(scrollPercentage() > 0) {
          <app-floating-navigation-button [type]="'left'" class="pointer-events-auto" (clicked)="onScrollLeft()"></app-floating-navigation-button>
        }
        @else {
          <div class="w-8 h-8 pointer-events-auto"></div>
        }

        <div class="flex-1"></div>

        @if(scrollPercentage() < 1) {
          <app-floating-navigation-button [type]="'right'" class="pointer-events-auto" (clicked)="onScrollRight()"></app-floating-navigation-button>
        }
        @else {
          <div class="w-8 h-8 pointer-events-auto"></div>
        }
      </div>
    </div>
  </div>

  <div class="absolute bottom-[1.625rem] left-0 right-0">
    <app-scroll-indicator
      [stepCount]="scrollSteps()"
      [progress]="scrollPercentage()">
    </app-scroll-indicator>
  </div>
</div>
